'use strict';
const _ = require('underscore');
const Ajax = require('common/infra/ajax');

class API {
    constructor() {
        this._cursors = {};
        this._mores = {};
    }

    _getHistoriesPath(projectId, actionId) {
        return `/api/projects/${projectId}/actions/${actionId}/histories`;
    }

    /**
     * Action の履歴を取得する
     *
     * @param projectId
     * @param actionId
     * @returns {*}
     */
    getNextHistories(projectId, actionId, limit) {
        return new Promise((resolve, reject) => {
            const path = this._getHistoriesPath(projectId, actionId);
            let extraHeaders = {};
            if(_.has(this._cursors, path)) {
                extraHeaders['X-Datastore-Cursor'] = this._cursors[path];
            }
            const p = Ajax.GET(`${path}?limit=${limit}`, {
                withResponseHeaders: true,
                extraHeaders: extraHeaders
            });
            p.then(value => {
                this._cursors[path] = value.headers.get('X-Datastore-Cursor');
                this._mores[path] = value.headers.get('X-Datastore-More') == 'true';
                resolve(value.data);
            }).catch(reject);
        });
    }

    hasNextHistory(projectId, actionId) {
        const path = this._getHistoriesPath(projectId, actionId);
        return _.has(this._mores, path) && this._mores[path];
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./process/infra/api/action/history.js